import { useState, useEffect, useRef } from 'react';

export const ServiceTabs = ({ 
  onServiceChange, 
  activeService, 
  availableServices = []
}) => {
  const [savedTab, setSavedTab] = useState(null);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const savedServiceName = localStorage.getItem('activeServiceName');
    const savedTimestamp = localStorage.getItem('activeTabTimestamp');
    const THIRTY_MINUTES = 30 * 60 * 1000;
    const now = Date.now();

    if (savedServiceName && savedTimestamp) {
      const timeElapsed = now - parseInt(savedTimestamp, 10);
      if (timeElapsed <= THIRTY_MINUTES) {
        const serviceExists = availableServices.find(
          s => s.serviceName.toLowerCase() === savedServiceName.toLowerCase()
        );
        if (serviceExists) {
          setSavedTab(savedServiceName);
          onServiceChange(savedServiceName);
        }
      } else {
        localStorage.removeItem('activeServiceName');
        localStorage.removeItem('activeTabTimestamp');
      }
    }
  }, [onServiceChange, availableServices]);

  // Scroll al servicio activo
  useEffect(() => {
    if (scrollContainerRef.current && activeService) {
      const activeTab = scrollContainerRef.current.querySelector(
        `[data-service="${activeService.toLowerCase()}"]`
      );
      if (activeTab) {
        activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }, [activeService]);

  const handleTabClick = (serviceName) => {
    onServiceChange(serviceName);
    localStorage.setItem('activeServiceName', serviceName);
    localStorage.setItem('activeTabTimestamp', Date.now().toString());
  };

  const sortedServices = [...availableServices].sort((a, b) => {
    // Usar el campo order si está disponible, de menor a mayor
    const orderA = a.order !== undefined ? a.order : 999;
    const orderB = b.order !== undefined ? b.order : 999;
    
    // Si tienen el mismo order, ordenar alfabéticamente como fallback
    if (orderA === orderB) {
      return (a.config?.label || a.serviceName).localeCompare(b.config?.label || b.serviceName);
    }
    
    return orderA - orderB;
  });

  if (availableServices.length === 0) {
    return <div className="service-tabs-loading">Cargando servicios...</div>;
  }

  return (
    <div className="service-tabs-container">
      <div className="service-tabs" ref={scrollContainerRef}>
        {sortedServices.map(({ serviceName, config }) => (
          <button
            key={serviceName}
            data-service={serviceName.toLowerCase()}
            id={`${config.id}-action`}
            className={`service-tab ${activeService?.toLowerCase() === serviceName.toLowerCase() ? 'active' : ''}`}
            onClick={() => handleTabClick(serviceName)}
            title={config.label}
          >
            {config.icon && (
              <img 
                src={config.icon} 
                alt={config.label}
                className="service-tab-icon"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            )}
            <span className="service-tab-label">{config.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
